export const SET_HOVER_CCHV = 'SET_HOVER_CCHV'

export function setCchv(obj){
    return (dispatch, getState) => {
        dispatch( {
            type: SET_HOVER_CCHV,
            payload: obj
        })
    }
} 